<div class="column--left" *ngIf="content">
  <app-picture
    [source]="content.fields.backgroundImage.fields.file.url"
    [isBackground]="true"
    [type]="'sidebar'"
    [alt]="''"
  >
  </app-picture>
  <div class="plan">
    <div class="plan__header">
      <span class="plan__title">{{ content.fields.heading }}</span>
    </div>
    <div class="plan__price" *ngIf="selectedPlan$ | async as selectedPlan">
      <div class="plan__name">{{ (selectedPlan$ | async).name[currentLocale$ | async] }}</div>
      <div class="plan__price-per-month">{{ selectedPlanTotal$ | async | round: 2 }}€</div>

      <span class="plan__price-per-month-label">{{ content.fields.perMonth }}</span>
      <span class="plan__price-per-day">
        ({{ selectedPlanDay$ | async | round: 2 }}€ / {{ content.fields.perDay }})
      </span>

      <div class="plan__description">
        {{ (selectedPlan$ | async).description[currentLocale$ | async] }}
      </div>
      <a class="plan__link" [routerLink]="content.fields.ctaLink">{{ content.fields.ctaText }}</a>
    </div>
  </div>
</div>
